import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "to", "activeClassName", "external", "partiallyActive", "anchor"];
import React, { useContext } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FaExternalLinkAlt, FaRegEnvelope } from 'react-icons/fa';
import { AiOutlinePhone } from 'react-icons/ai';
import { AnchorLink } from '@interness/gatsby-plugin-anchor-links';
import { GlobalContext, LanguageContext } from '../../../providers';
import { isLinkExternal } from '../../_helpers';
import routes from '../../../../config/routes';

// TODO refactor this mess with different components
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Link = props => {
  let {
      children,
      to,
      activeClassName,
      external,
      partiallyActive,
      anchor
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  const {
    href
  } = other;
  const {
    language
  } = useContext(LanguageContext);
  const {
    togglePrimaryMenu,
    onSidebarClose
  } = useContext(GlobalContext);
  const onClickHandler = () => {
    togglePrimaryMenu(false);
    onSidebarClose();
    if (other.onClick) {
      other.onClick();
    }
  };
  let route;
  if (to && to.charAt(0) === '/') {
    route = to.substr(1);
  }
  const isRoute = !!routes[route];

  // Anchor
  if (anchor) {
    return ___EmotionJSX(AnchorLink, _extends({
      to: `${to}#${anchor}`
    }, other, {
      onClick: () => onClickHandler()
    }), children);
  }

  // Link from MDX
  if (href && !to && !isLinkExternal(href) && !href.startsWith('mailto:')) {
    to = href;
  }
  if (isLinkExternal(to) || external || !to) {
    if (to && !to.startsWith('mailto:') && !to.startsWith('/static/') && !to.startsWith('tel:')) {
      if (!isLinkExternal(to)) {
        // In case of 'external' prop
        to = `//${to}`;
      }
    }
    if (to) {
      return ___EmotionJSX("a", _extends({
        href: to
      }, other, {
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onClickHandler
      }), to.startsWith('mailto:') ? ___EmotionJSX(FaRegEnvelope, {
        style: {
          verticalAlign: 'middle',
          marginRight: '5px'
        }
      }) : to.startsWith('tel:') ? ___EmotionJSX(AiOutlinePhone, {
        style: {
          verticalAlign: 'text-top',
          marginRight: '5px'
        }
      }) : ___EmotionJSX(FaExternalLinkAlt, {
        style: {
          verticalAlign: 'text-top',
          marginRight: '5px'
        }
      }), children);
    } else {
      return (
        //eslint-disable-next-line
        ___EmotionJSX("a", _extends({
          style: {
            cursor: 'pointer'
          }
        }, other, {
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: onClickHandler
        }), ___EmotionJSX(FaExternalLinkAlt, {
          style: {
            verticalAlign: 'middle',
            marginRight: '5px'
          }
        }), " ", children)
      );
    }
  } else {
    return ___EmotionJSX(GatsbyLink, _extends({
      to: isRoute ? routes[route][language] : to,
      activeClassName: activeClassName,
      partiallyActive: partiallyActive
    }, other, {
      onClick: onClickHandler
    }), children);
  }
};
export default Link;